<template>
    <Spin :spinning="loading">
        <Layout style="height: 100%; min-height: 500px">
            <!-- <Header class="header" style="background: #1DA57A;">
                <p class="title">点播中台</p>
            </Header> -->
            <Alert v-if="showNoRole" style="margin: 20px" message="暂无权限" type="warning" show-icon></Alert>

            <!-- 登录过期 -->
            <div class="get-role" v-if="loginOut">
                <div class="login-wrap">
                    <div v-if="loading">获取身份</div>
                    <div class="hint-wrap">
                        <Divider orientation="left">未登录</Divider>
                        <p>您的登录已过期，<br/> <br/></p>
                    </div>
                </div>
            </div>
            <!-- 顶部 -->
            <div style="width:100%;height:100px;background:#ffffff;">
                <img src="../assets/logo.png"/>
                <div style="float:right;margin:70px 10px 0px 0px;cursor:pointer;color:#40a9ff;" @click="logout()">点此退出</div>
                <div style="float:right;margin:70px 10px 0px 0px;cursor:pointer;color:#40a9ff;" @click="password()">修改密码</div>
                <div style="float:right;margin:70px 20px 0px 0px;">欢迎，{{username}}</div>
            </div>
            <Layout v-if="showContent" style="height: 100%;border-top:1px solid #cccccc;">
                <!-- 侧边栏 -->
                <Sider width="200" style="background: #fff" v-model="collapsed" :trigger="null" collapsible>
                    <Menu
                            style="height: 100%"
                            mode="inline"
                            :selectedKeys="seleckKey"
                            :openKeys.sync="openKey"
                    >

                        <template v-for="(item) in menu">
                            <customSubMeu @gotoItem="gotoItem" :key="item.key" :menuInfo="item"></customSubMeu>
                        </template>

                    </Menu>
                </Sider>
                <Layout>
                    <Content>
                        <div class="wrap">
                            <div class="page-header">
                                <div class="header">
                                    <Button @click="toggleCollapsed">
                                        <Icon :type="collapsed ? 'menu-unfold' : 'menu-fold'"></Icon>
                                    </Button>
                                    <p class="header-title">{{$route.meta.title}}</p>

                                    <Select
                                            v-if="false && appChangeList[0] && !$route.meta.hiddenApplication"
                                            style="width:170px; margin-right:15px"
                                            :defaultValue='appId'
                                            :defaultActiveFirstOption="true"
                                            @change="handleApp"
                                    >
                                        <Option v-for="item in appChangeList" :key="item.appId">{{item.name}}</Option>
                                    </Select>
                                </div>
                            </div>
                            <div class="content-wrap" :class="{'bg-white': !$route.meta.hiddenBackgroundColor}">
                                <router-view></router-view>
                            </div>
                        </div>

                    </Content>
                </Layout>
            </Layout>
        </Layout>
    </Spin>
</template>

<script>
    import {Layout, Menu, Icon, Select, Button, Alert, Spin, Divider} from 'ant-design-vue'
    import adminConfig from '@util/adminConfig'
    import appConfig from '@util/appConfig'
    import guestConfig from '@util/guestConfig'
    import {ManageApi} from '@service/api'
    import {mapGetters} from 'vuex'
    import {queryURL} from '@util/tool'
    import getDomain from '@service/domian'
    import {TestApi} from '@service/domainConfig'
    import userConfig from '@util/userConfig'

    const vodDomain = getDomain(TestApi);
    const {Sider, Content} = Layout
    const {SubMenu, Item} = Menu
    const {Option} = Select
    const customSubMeu = {
        template: `
            <SubMenu :key="menuInfo.key" v-bind="$props" v-on="$listeners">
                <span slot="title"><Icon :type='menuInfo.icon'></Icon><span>{{menuInfo.menu}}</span></span>
                <template v-for="child in menuInfo.childen">
                    <Item :key="child.subKey">
                        <a @click="gotoItem(child, menuInfo)">{{child.subMenu}}</a>
                    </Item>
                </template>
            </SubMenu>
        `,
        name: 'customSubMeu',
        props: {
            ...Menu.SubMenu.props,
            menuInfo: {
                type: Object,
                default: () => ({}),
            }
        },
        isSubMenu: true,
        components: {
            SubMenu,
            Item,
            Icon
        },
        methods: {
            gotoItem(subMenu, menu) {
                this.$emit('gotoItem', subMenu, menu)
            },
        }
    }
    export default {
        data() {
            return {
                menu: [],
                adminConfig,
                userConfig,
                openKey: [],
                openKeyCopy: [],
                // 控制侧边栏显隐
                collapsed: false,
                // 首次加载route
                firstLoadRoute: true,
                // 应用列表
                appChangeList: [],
                loading: true,
                show: false,
                // 没权限
                noRole: false,
                // 未登录
                loginOutFlag: false,
                username: localStorage.getItem("username")
            }
        },
        created() {
            this.getRole();
            window.setTimeout(this.refreshToken, 1000 * 60 * 20);
        },
        mounted() {
            this.guest = [...guestConfig];
            this.menu = [...appConfig, ...userConfig]
        },
        computed: {
            ...mapGetters(['appFlag', 'appId']),
            showNoRole() {
                return this.noRole && !this.loading
            },
            loginOut() {
                // return this.loginOutFlag && !this.loading
                return false
            },
            isIfname() {
                return window.self !== window.top
            },
            openPage() {
                // return this.isIfname && this.appChangeList.length
                return false
            },
            showContent() {
                // return !this.isIfname && this.appChangeList.length
                return this.appChangeList.length
            }
        },
        watch: {
            appFlag() {
                // 操作应用
                this.getRole('updata')
            }
        },
        methods: {
            // 获取身份
            getRole(str) {
                // if(this.isLogin() && !str) {
                //     this.setRoleInfo()
                // }
                this.loading = true
                ManageApi.getUserRole().then(res => {
                    this.loading = false
                    if (res.status === 100000) {
                    console.log(res)
                        const {data} = res
                        const {roleType, appList} = data
                        if (!str) {
                            if (+roleType === 1) {
                                this.menu = [...this.menu, ...adminConfig]
                                this.$store.dispatch('IS_ADMIN', true)
                            }else{
                                this.menu = [...this.guest]
                                this.$store.dispatch('IS_ADMIN', false)
                            }
                            if (appList.length) {
                                this.$store.dispatch('APPID', appList[0].appId)
                            } else {
                                // 暂无权限
                                this.noRole = true
                            }
                            this.openKey = this.menu.map(item => item.key)
                            this.openKeyCopy = this.openKey
                        }
                        let key = [this.$route.name || this.$route.meta.subKey]
                        if (this.$route.name === 'mediaItem' || this.$route.meta.subKey === 'mediaItem') {
                            key = ['media']
                        }
                        this.seleckKey = key

                        this.appChangeList = appList

                    } else {
                        // 没接登录提示无权限
                        this.noRole = true
                        // 未登录
                        this.loginOutFlag = true
                        //
                        location.href="../login.html";
                    }
                }).then(() => {
                    this.loading = false
                })
            },
            // 切换角色
            handleApp(val) {
                this.$store.dispatch('APPID', val)
            },
            // 控制侧边栏显隐
            toggleCollapsed() {
                this.collapsed = !this.collapsed
                if (this.collapsed) {
                    this.openKey = []
                } else {
                    this.openKey = this.openKeyCopy
                }

            },
            gotoItem(subMenu) {
                const {subKey, routerName} = subMenu
                this.seleckKey = [subKey]
                if (this.$route.name === routerName) return
                const hash = location.hash
                this.$router.push({
                    name: routerName
                })
            },
            // 登录地址
            isLogin() {
                const hash = location.hash
                const reg = /^#\/login.+/
                return reg.test(hash)
            },
            // 种local storage
            setRoleInfo() {
                const hash = location.hash
                const sessionId = queryURL('sessionId', hash)
                const userId = queryURL('userId', hash)
                window.localStorage.setItem('sessionId', sessionId)
                window.localStorage.setItem('userId', userId)
            },
            password(){
                this.$router.push({
                    name: "password"
                })
            },
            logout(){
                location.href="../login.html";
            },
            refreshToken(){
                ManageApi.refreshToken().then(res => {
                    if (res.status === 100000) {
                        localStorage.setItem("token", res.data);
                    }
                });
                var that = this;
                window.setTimeout(function(){
                    that.refreshToken();
                },1000 * 60 * 20);
            }
        },
        components: {
            Layout,
            Sider,
            Menu,
            Content,
            Select,
            Option,
            Button,
            customSubMeu,
            Alert,
            Spin,
            Divider,
            Icon
        }
    }
</script>

<style lang="less" scoped>
    .header {
        display: flex;
        align-items: center;

        .title {
            color: #fff;
            font-size: 18px;
            flex: 1;
        }
    }

    .page-header {
        padding: 0 20px;
        height: 80px;
        background: #fff;
        border-bottom: 1px solid rgb(235, 237, 240);

        .header {
            width: 100%;
            height: 100%;
            background: #fff;
            box-sizing: border-box;
            display: flex;
            align-items: center;
        }

        .header-title {
            font-size: 16px;
            padding-left: 15px;
            flex: 1;
        }
    }

    .content-wrap {
        margin: 15px;
    }

    .bg-white {
        background: #fff;
        padding: 20px 20px 40px;
    }

    .get-role {
        margin: 20px;
        padding: 20px;
        background: #fff;
    }

    .login-wrap {
        display: flex;
        height: 200px;
        align-items: center;
        font-size: 15px;
    }

    .hint-wrap {
        width: 100%;
        padding: 24px;

        p {
            font-size: 14px;
            color: #333;
        }

        .open-btn {
            margin-bottom: 20px;
        }
    }
</style>